module.exports = __webpack_public_path__ + "img/zm.ac9f8923.svg";